export const directories = [
  {
    type: "railways",
    label: "Дороги",
    description: "Справочник железных дорог",
    acceptedFormats: ".xlsx, .xls",
  },
  {
    type: "stations",
    label: "Станции ЖД",
    description: "Справочник железнодорожных станций",
    acceptedFormats: ".xlsx, .xls",
  },
  {
    type: "etsngs",
    label: "Коды ЕТСНГ",
    description: "Справочник кодов ЕТСНГ",
    acceptedFormats: ".xlsx, .xls",
  },
  {
    type: "wagonModels",
    label: "Модели ПС",
    description: "Справочник моделей подвижного состава",
    acceptedFormats: ".xlsx, .xls",
  },
] as const;
